import camelcaseKeys from "camelcase-keys";
import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import config from "config";
import { AXIOS } from "hooks/axios";
import { MetaSchema, PaginationSchema } from "hooks/pagination";

const USER_SERVICE_BASE_URL = config.url.USER_SERVICE;

export type UserAuditLog = {
  id: string;
  url: string;
  type: string;
  host: string;
  email: string;
  status: "success" | "canceled" | "failed";
  project: string;
  message: string;
  updatedAt: string;
};

export const useUserServiceAuditLogs = (body: PaginationSchema) => {
  return useQuery<
    AxiosResponse<any, any>,
    AxiosError<{ message: string }>,
    { data: UserAuditLog[]; meta: MetaSchema }
  >(
    [`USER SERVICE AUDIT ${JSON.stringify(body)}`],
    () => AXIOS.post(`${USER_SERVICE_BASE_URL}/audit`, body),
    {
      retry: 2,
      select: (data) => camelcaseKeys(data.data, { deep: true }),
    }
  );
};
